/* import __COLOCATED_TEMPLATE__ from './bottom.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();